import React from 'react';
import { getUserToken } from 'lib/storage';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoutes = () => {
  const token = getUserToken();

  return (
    token ? <Outlet /> : <Navigate to={"/"} />
  );
};

export default PrivateRoutes;
